export function openPopup(fileBytes){
    const file = new Blob([fileBytes], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
}

export function downloadFile(fileBytes, fileName){
    const url = window.URL.createObjectURL(
        new Blob([fileBytes]),
    );
    // const url = fileBytes;
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.setAttribute(
        'download',
        `${fileName}`,
    );
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

/**
 * Export an array of objects to a CSV file
 * @param {Array} data - Array of objects to export
 * @param {string} fileName - Name of the output file (without extension)
 */
export function exportToCSV(data, fileName = 'export') {
    if (!data || data.length === 0) {
        console.warn('No data to export');
        return;
    }
    
    // Get headers from the first object
    const headers = Object.keys(data[0]);
    
    // Create CSV content
    const csvContent = [
        // Header row
        headers.map(h => `"${h}"`).join(','),
        // Data rows
        ...data.map(row => 
            headers.map(header => {
                const value = row[header];
                // Handle null/undefined
                if (value === null || value === undefined) return '""';
                // Convert to string and escape quotes
                const stringValue = String(value).replace(/"/g, '""');
                return `"${stringValue}"`;
            }).join(',')
        )
    ].join('\n');
    
    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}_${new Date().toISOString().split('T')[0]}.csv`;
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}